// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import StandardSpinner from '../../../utils/Spinner';
// import timeZones from "../../../assets/data/timeZone";
// import { formatInTimezone } from '../../../utils/FormateInTimeZone';
// import { SetTimeZone, Org_SetTimeZone } from "../../../services/oprations/TimeZone";
// import { OrgChangePassword, ManagerChangePassword,profile } from "../../../services/oprations/Auth";
// // import toast from "react-hot-toast";
// import { useToast } from "../../Toast";
// import useSocket from "../../../hooks/useSocket";

// const ProfileOverview = () => {
//   const toast = useToast();
//   const dispatch = useDispatch();
//   const socket = useSocket()
//   const [loading, setloading] = useState(true);
//   const [activeUser, setActiveUser] = useState(null);
//   const [activeDevice, setActiveDevice] = useState(null);
//   const [isTimeZoneOpen, setIsTimeZoneOpen] = useState(false);
//   const [selectedTimeZone, setSelectedTimeZone] = useState('');
//   const [searchTerm, setSearchTerm] = useState('');
  
//   // State for 3-dot menu
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
  
//   // State for change password modal
//   const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: ""
//   });
//   const [passwordLoading, setPasswordLoading] = useState(false);
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
//   const { user } = useSelector((state) => state.profile);
//   const { users } = useSelector((state) => state.user);
//   const { devices } = useSelector((state) => state.device);
//   const token = useSelector((state) => state.auth.token);

//   // Parse user if it's a string
//   const userData = typeof user === 'string' ? JSON.parse(user) : user;
//   console.log("User Details:", userData);
  
//   const allusers = typeof users === 'string' ? JSON.parse(users) : users;
//   const alldevices = typeof devices === 'string' ? JSON.parse(devices) : devices;

//   // Get role-specific display name and email
//   const getDisplayName = () => {
//     if (userData?.role === 'Manager') {
//       return userData?.manager_name || 'N/A';
//     } else if (userData?.role === 'Organization') {
//       return userData?.org_name || 'N/A';
//     }
//     return userData?.name || 'N/A';
//   };

//   const getDisplayEmail = () => {
//     if (userData?.role === 'Manager') {
//       return userData?.manager_email || 'N/A';
//     } else if (userData?.role === 'Organization') {
//       return userData?.org_email || 'N/A';
//     }
//     return userData?.email || 'N/A';
//   };

//   const getInitials = () => {
//     const name = getDisplayName();
//     return name.charAt(0).toUpperCase();
//   };

//   const getLocation = () => {
//     if (userData?.role === 'Manager') {
//       return userData?.org_id?.location || userData?.location || 'Not specified';
//     } else {
//       return userData?.location || 'Not specified';
//     }
//   };

//   const getLicenseKey = () => {
//     if (userData?.role === 'Manager') {
//       return userData?.org_id?.license_key || 'N/A';
//     } else {
//       return userData?.license_key || 'N/A';
//     }
//   };

//   const getOrganizationName = () => {
//     if (userData?.role === 'Manager') {
//       return userData?.org_id?.org_name || 'N/A';
//     }
//     return null;
//   };

//   const getTotalDevices = () => {
//     if (userData?.role === 'Manager') {
//       return alldevices.length || 0;
//     } else {
//       return alldevices.length || 0;
//     }
//   };

//   const getTotalUsers = () => {
//     console.log("uerData.....",userData)
//     if (userData?.role === 'Manager') {
//       return allusers.length || 0;
//     } else {
//       return allusers.length || 0;
//     }
//   };

//   useEffect(() => {
//       if (!socket) return;
  
//       socket.on("Notification_Status", (data) => {
//         console.log("Notification:",data)
//         dispatch(profile(token))
//       });
  
//       return () => {
//         socket.off("Notification_Status");
//       };
//     }, [socket, dispatch, token]);

//   useEffect(() => {
//     setTimeout(() => {
//       setloading(false);
//     }, 800);
//   }, []);

//   useEffect(() => {
//     if (allusers && Array.isArray(allusers)) {
//       let activeusers = allusers?.filter((u) => u.status === true || u.status === 'ACTIVE');
//       console.log("Active Users:", activeusers);
//       setActiveUser(activeusers?.length || 0);
//       console.log("All users :>",allusers)
//     }
    
//     if (alldevices && Array.isArray(alldevices)) {
//       let activedevices = alldevices?.filter((d) => d.last_status === 'ONLINE' || d.last_status === 'HEARTBEAT');
//       setActiveDevice(activedevices?.length || 0);
//       console.log("All Devices:?>",alldevices)
//     }
//   }, [users, devices]);

//   // Get user's current timezone
//   useEffect(() => {
//     const savedTimeZone = userData?.timeZone;
//     if (savedTimeZone && savedTimeZone.timezone) {
//       setSelectedTimeZone(savedTimeZone.timezone);
//     } else {
//       const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//       const matchedTimeZone = timeZones.find(tz => 
//         browserTimeZone.toLowerCase().includes(tz.value.toLowerCase().split(' ')[0].toLowerCase())
//       ) || timeZones[12];
      
//       if (userData?.role === 'Manager') {
//         dispatch(SetTimeZone({timezone: matchedTimeZone.name, value: matchedTimeZone.value}));
//       } else {
//         dispatch(Org_SetTimeZone({timezone: matchedTimeZone.name, value: matchedTimeZone.value}));
//       }
//       setSelectedTimeZone(matchedTimeZone.name);
//     }
//   }, []);

//   const handleTimeZoneChange = (timeZone) => {
//     setSelectedTimeZone(timeZone.name);
//     if (userData?.role === 'Manager') {
//       dispatch(SetTimeZone({timezone: timeZone.name, value: timeZone.value}));
//     } else {
//       dispatch(Org_SetTimeZone({timezone: timeZone.name, value: timeZone.value}));
//     }
//     setIsTimeZoneOpen(false);
//     setSearchTerm('');
//   };

//   // Handle password change
//   const handleChangePassword = async () => {
//     // Validation
//     if (!passwordForm.currentPassword) {
//       toast.error("Please enter current password");
//       return;
//     }
//     if (!passwordForm.newPassword) {
//       toast.error("Please enter new password");
//       return;
//     }
//     if (passwordForm.newPassword.length < 6) {
//       toast.error("New password must be at least 6 characters long");
//       return;
//     }
//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       toast.error("New password and confirm password do not match");
//       return;
//     }

//     setPasswordLoading(true);
    
//     const payload = {
//       oldPassword: passwordForm.currentPassword,
//       newPassword: passwordForm.newPassword,
//       confirmPassword: passwordForm.newPassword
//     };

//     try {
//       let response;
//       if (userData?.role === 'Manager') {
//         response = await dispatch(ManagerChangePassword(payload, token));
//       } else {
//         response = await dispatch(OrgChangePassword(payload, token));
//       }
      
//       if (response?.data?.success) {
//         setIsPasswordModalOpen(false);
//         setPasswordForm({
//           currentPassword: "",
//           newPassword: "",
//           confirmPassword: ""
//         });
//         toast.success(response.data.message || "Password changed successfully");
//       }
//       else {
//         toast.error(response.data.message || "Error changing password");
//       }
//     } catch (error) {
//       console.error("Password change error:", error);
//     } finally {
//       setPasswordLoading(false);
//     }
//   };

//   const handlePasswordInputChange = (e) => {
//     setPasswordForm({
//       ...passwordForm,
//       [e.target.name]: e.target.value
//     });
//   };

//   // Close menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMenuOpen && !event.target.closest('.menu-container')) {
//         setIsMenuOpen(false);
//       }
//     };
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, [isMenuOpen]);

//   const filteredTimeZones = timeZones.filter(tz =>
//     tz.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     tz.value.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   if (loading) {
//     return <StandardSpinner />;
//   }

//   if (!userData) {
//     return (
//       <section className="p-6 bg-gray-900 border shadow-xl border-blue-800/40 rounded-2xl shadow-blue-900/20">
//         <div className="py-8 text-center">
//           <p className="text-blue-300">No user data available</p>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="p-6 bg-gray-900 border shadow-xl border-blue-800/40 rounded-2xl shadow-blue-900/20">
//       {/* Header with 3-dot button */}
//       <div className="flex items-center justify-between mb-6">
//         <h2 className="flex items-center gap-2 text-xl font-semibold text-blue-100">
//           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//             <path
//               fillRule="evenodd"
//               d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
//               clipRule="evenodd"
//             />
//           </svg>
//           Profile Overview
//         </h2>
        
//         {/* 3-Dot Button Menu */}
//         <div className="relative menu-container">
//           <button
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//             className="p-2 transition-colors rounded-lg hover:bg-gray-800 focus:outline-none"
//           >
//             <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
//               <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
//             </svg>
//           </button>
          
//           {/* Dropdown Menu */}
//           {isMenuOpen && (
//             <div className="absolute right-0 z-50 w-48 mt-2 bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
//               <button
//                 onClick={() => {
//                   setIsMenuOpen(false);
//                   setIsPasswordModalOpen(true);
//                 }}
//                 className="flex items-center w-full gap-2 px-4 py-2 text-left text-gray-300 transition-colors rounded-lg hover:bg-gray-700 hover:text-white"
//               >
//                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
//                 </svg>
//                 Change Password
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
//         {/* Profile Info */}
//         <div className="space-y-4 lg:col-span-2">
//           <div className="flex items-start gap-4">
//             <div className="flex items-center justify-center w-20 h-20 text-2xl font-bold text-white border-2 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//               {getInitials()}
//             </div>

//             <div>
//               <h3 className="text-2xl font-bold text-white">
//                 {getDisplayName()}
//               </h3>
//               <p className="text-blue-300">{userData?.role || "N/A"}</p>
//               <p className="text-sm text-gray-400 ">
//                 {getDisplayEmail()}
//               </p>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-4 pt-4 md:grid-cols-3">
//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">Role</p>
//               <p className="text-sm font-medium text-white">
//                 {userData?.role || "N/A"}
//               </p>
//             </div>

//             {userData?.role === "Manager" && userData?.department && (
//               <div className="p-3 rounded-lg bg-gray-800/50">
//                 <p className="mb-1 text-xs text-blue-200">Department</p>
//                 <p className="text-sm font-medium text-white">
//                   {userData?.department}
//                 </p>
//               </div>
//             )}

//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">Location</p>
//               <p className="text-sm font-medium text-white">
//                 {getLocation()}
//               </p>
//             </div>

//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">License Key</p>
//               <p className="font-mono text-sm font-medium text-white">
//                 {getLicenseKey() !== 'N/A' && getLicenseKey() !== 'Secret' 
//                   ? `${getLicenseKey().substring(0, 8)}...` 
//                   : getLicenseKey()}
//               </p>
//             </div>

//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">Status</p>
//               <p className="font-medium text-white">
//                 <span className={`px-2 py-1 rounded-full text-xs ${
//                   userData?.status === true || userData?.status === 'ACTIVE' 
//                     ? 'bg-green-500/20 text-green-400' 
//                     : 'bg-red-500/20 text-red-400'
//                 }`}>
//                   {userData?.status === true || userData?.status === 'ACTIVE' ? "Active" : "Inactive"}
//                 </span>
//               </p>
//             </div>

//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">Member since</p>
//               <p className="text-xs font-medium text-white">
//                 {userData?.createdAt ? new Date(userData.createdAt).toLocaleDateString() : 'N/A'}
//               </p>
//             </div>

//             <div className="p-3 rounded-lg bg-gray-800/50">
//               <p className="mb-1 text-xs text-blue-200">Last updated</p>
//               <p className="text-xs font-medium text-white">
//                 {userData?.updatedAt ? new Date(userData.updatedAt).toLocaleDateString() : 'N/A'}
//               </p>
//             </div>

//             {userData?.role === "Manager" && getOrganizationName() && (
//               <div className="p-3 rounded-lg bg-gray-800/50">
//                 <p className="mb-1 text-xs text-blue-200">Organization</p>
//                 <p className="text-sm font-medium text-white">
//                   {getOrganizationName()}
//                 </p>
//               </div>
//             )}

//             {userData?.role === "Organization" && userData?.wallet && (
//               <div className="p-3 rounded-lg bg-gray-800/50">
//                 <p className="mb-1 text-xs text-blue-200">Wallet Balance</p>
//                 <p className="text-sm font-medium text-white">
//                   ₹{userData?.wallet?.balance || 0}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Profile Stats and TimeZone */}
//         <div className="space-y-4">
//           {/* Quick Stats */}
//           <div className="p-4 border bg-gray-800/50 rounded-xl border-blue-800/30">
//             <h4 className="mb-4 font-medium text-blue-100">Quick Stats</h4>

//             <div className="space-y-4">
//               <div>
//                 <div className="flex items-center justify-between mb-1">
//                   <span className="text-sm text-gray-400">Active Devices</span>
//                   <span className="text-lg font-bold text-white">
//                     {activeDevice || 0} / {getTotalDevices()}
//                   </span>
//                 </div>
//                 <div className="w-full h-2 bg-gray-900 rounded-full">
//                   <div
//                     className="h-2 transition-all duration-500 bg-blue-600 rounded-full"
//                     style={{
//                       width: `${getTotalDevices() > 0 
//                         ? (Number(activeDevice || 0) / Number(getTotalDevices())) * 100 
//                         : 0}%`
//                     }}
//                   ></div>
//                 </div>
//               </div>

//               <div>
//                 <div className="flex items-center justify-between mb-1">
//                   <span className="text-sm text-gray-400">Active Users</span>
//                   <span className="text-lg font-bold text-white">
//                     {activeUser || 0} / {getTotalUsers()}
//                   </span>
//                 </div>
//                 <div className="w-full h-2 bg-gray-900 rounded-full">
//                   <div
//                     className="h-2 transition-all duration-500 bg-blue-600 rounded-full"
//                     style={{ 
//                       width: `${getTotalUsers() > 0 
//                         ? (Number(activeUser || 0) / Number(getTotalUsers())) * 100 
//                         : 0}%` 
//                     }}
//                   ></div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* TimeZone Section */}
//           <div className="p-4 border bg-gray-800/50 rounded-xl border-blue-800/30">
//             <div className="flex items-center justify-between mb-4">
//               <h4 className="flex items-center gap-2 font-medium text-blue-100">
//                 <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                 </svg>
//                 Time Zone
//               </h4>
//             </div>

//             {/* Selected TimeZone Display */}
//             <div 
//               onClick={() => setIsTimeZoneOpen(!isTimeZoneOpen)}
//               className="w-full p-3 transition-colors bg-gray-900 border rounded-lg cursor-pointer border-blue-800/30 hover:border-blue-600/50"
//             >
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm font-medium text-white">
//                     {selectedTimeZone || 'Select Time Zone'}
//                   </p>
//                   <p className="mt-1 text-xs text-blue-200">
//                     {timeZones.find(tz => tz.name === selectedTimeZone)?.value || ''}
//                   </p>
//                 </div>
//                 <svg 
//                   className={`h-5 w-5 text-gray-400 transition-transform ${isTimeZoneOpen ? 'rotate-180' : ''}`} 
//                   fill="currentColor" 
//                   viewBox="0 0 20 20"
//                 >
//                   <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
//                 </svg>
//               </div>
//             </div>

//             {/* TimeZone Dropdown */}
//             {isTimeZoneOpen && (
//               <div className="mt-2 overflow-hidden bg-gray-900 border rounded-lg border-blue-800/30">
//                 {/* Search Input */}
//                 <div className="p-2 border-b border-blue-800/30">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search timezone..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       className="w-full py-2 pl-8 pr-3 text-sm text-white bg-gray-800 border rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 border-blue-800/30"
//                     />
//                     <svg 
//                       className="h-4 w-4 text-gray-400 absolute left-2.5 top-2.5" 
//                       fill="none" 
//                       stroke="currentColor" 
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   </div>
//                 </div>

//                 {/* TimeZone List */}
//                 <div className="overflow-y-auto max-h-48 custom-scrollbar">
//                   {filteredTimeZones.map((tz, index) => (
//                     <div
//                       key={index}
//                       onClick={() => handleTimeZoneChange(tz)}
//                       className={`px-3 py-2 cursor-pointer hover:bg-blue-600/20 transition-colors ${
//                         selectedTimeZone === tz.name ? 'bg-blue-600/30 border-l-2 border-blue-500' : ''
//                       }`}
//                     >
//                       <p className="text-sm text-white">{tz.name}</p>
//                       <p className="text-xs text-blue-400">{tz.value}</p>
//                     </div>
//                   ))}
//                   {filteredTimeZones.length === 0 && (
//                     <div className="px-3 py-4 text-sm text-center text-gray-400">
//                       No timezones found
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* TimeZone Info */}
//             <div className="flex items-center gap-1 mt-3 text-xs text-gray-400">
//               <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
//               </svg>
//               <span>Your timezone affects how dates and times are displayed</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Change Password Modal */}
//       {isPasswordModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
//           <div className="w-full max-w-md p-6 bg-gray-800 border border-blue-700 shadow-2xl rounded-xl">
//             <div className="flex items-center justify-between mb-4">
//               <h2 className="text-2xl font-bold text-white">Change Password</h2>
//               <button
//                 onClick={() => setIsPasswordModalOpen(false)}
//                 className="text-gray-400 transition-colors hover:text-white"
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
            
//             <form onSubmit={(e) => { e.preventDefault(); handleChangePassword(); }}>
//               {/* Current Password */}
//               <div className="mb-4">
//                 <label className="block mb-2 text-sm font-medium text-blue-300">
//                   Current Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showCurrentPassword ? "text" : "password"}
//                     name="currentPassword"
//                     value={passwordForm.currentPassword}
//                     onChange={handlePasswordInputChange}
//                     className="w-full px-4 py-2 pr-10 text-white bg-gray-900 border border-gray-700 rounded-lg focus:outline-none focus:border-blue-500"
//                     placeholder="Enter current password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowCurrentPassword(!showCurrentPassword)}
//                     className="absolute right-3 top-2.5 text-gray-400 hover:text-white"
//                   >
//                     {showCurrentPassword ? (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                       </svg>
//                     ) : (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                       </svg>
//                     )}
//                   </button>
//                 </div>
//               </div>

//               {/* New Password */}
//               <div className="mb-4">
//                 <label className="block mb-2 text-sm font-medium text-blue-300">
//                   New Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showNewPassword ? "text" : "password"}
//                     name="newPassword"
//                     value={passwordForm.newPassword}
//                     onChange={handlePasswordInputChange}
//                     className="w-full px-4 py-2 pr-10 text-white bg-gray-900 border border-gray-700 rounded-lg focus:outline-none focus:border-blue-500"
//                     placeholder="Enter new password (min 6 characters)"
//                     required
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowNewPassword(!showNewPassword)}
//                     className="absolute right-3 top-2.5 text-gray-400 hover:text-white"
//                   >
//                     {showNewPassword ? (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                       </svg>
//                     ) : (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                       </svg>
//                     )}
//                   </button>
//                 </div>
//               </div>

//               {/* Confirm Password */}
//               <div className="mb-6">
//                 <label className="block mb-2 text-sm font-medium text-blue-300">
//                   Confirm New Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     name="confirmPassword"
//                     value={passwordForm.confirmPassword}
//                     onChange={handlePasswordInputChange}
//                     className="w-full px-4 py-2 pr-10 text-white bg-gray-900 border border-gray-700 rounded-lg focus:outline-none focus:border-blue-500"
//                     placeholder="Confirm new password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                     className="absolute right-3 top-2.5 text-gray-400 hover:text-white"
//                   >
//                     {showConfirmPassword ? (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                       </svg>
//                     ) : (
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                       </svg>
//                     )}
//                   </button>
//                 </div>
//               </div>

//               {/* Password Strength Indicator */}
//               {passwordForm.newPassword && (
//                 <div className="mb-4">
//                   <div className="flex justify-between mb-1 text-xs text-gray-400">
//                     <span>Password strength:</span>
//                     <span>
//                       {passwordForm.newPassword.length < 6 ? "Too short" :
//                        passwordForm.newPassword.length < 8 ? "Weak" :
//                        passwordForm.newPassword.match(/[!@#$%^&*(),.?":{}|<>]/) ? "Strong" : "Medium"}
//                     </span>
//                   </div>
//                   <div className="w-full bg-gray-700 rounded-full h-1.5">
//                     <div 
//                       className={`h-1.5 rounded-full transition-all ${
//                         passwordForm.newPassword.length < 6 ? "bg-red-500 w-1/4" :
//                         passwordForm.newPassword.length < 8 ? "bg-yellow-500 w-2/4" :
//                         passwordForm.newPassword.match(/[!@#$%^&*(),.?":{}|<>]/) ? "bg-green-500 w-full" : "bg-blue-500 w-3/4"
//                       }`}
//                     ></div>
//                   </div>
//                 </div>
//               )}

//               {/* Action Buttons */}
//               <div className="flex gap-3">
//                 <button
//                   type="button"
//                   onClick={() => setIsPasswordModalOpen(false)}
//                   className="flex-1 px-4 py-2 text-white transition-colors bg-gray-700 rounded-lg hover:bg-gray-600"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={passwordLoading}
//                   className="flex items-center justify-center flex-1 gap-2 px-4 py-2 text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {passwordLoading ? (
//                     <>
//                       <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                       </svg>
//                       Changing...
//                     </>
//                   ) : (
//                     "Change Password"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Add custom scrollbar styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 6px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: #1f2937;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: #3b82f6;
//           border-radius: 3px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: #2563eb;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default ProfileOverview;

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import StandardSpinner from '../../../utils/Spinner';
import timeZones from "../../../assets/data/timeZone";
//import { formatInTimezone } from '../../../utils/FormateInTimeZone';
import { SetTimeZone, Org_SetTimeZone } from "../../../services/oprations/TimeZone";
import { OrgChangePassword, ManagerChangePassword,profile } from "../../../services/oprations/Auth";
import { useToast } from "../../Toast";
import useSocket from "../../../hooks/useSocket";
import { useTheme } from '../../../Context/themeContext';

const ProfileOverview = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const toast = useToast();
  const dispatch = useDispatch();
  const socket = useSocket()
  const [loading, setloading] = useState(true);
  const [activeUser, setActiveUser] = useState(null);
  const [activeDevice, setActiveDevice] = useState(null);
  const [isTimeZoneOpen, setIsTimeZoneOpen] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const { user } = useSelector((state) => state.profile);
  const { users } = useSelector((state) => state.user);
  const { devices } = useSelector((state) => state.device);
  const token = useSelector((state) => state.auth.token);

  // ─── Theme-aware classes ──────────────────────────────────────────────
  //const bgPrimary = isDark ? 'bg-gray-900' : 'bg-gray-50';
  const bgCard = isDark ? 'bg-gray-900' : 'bg-white';
  const bgSection = isDark ? 'bg-gray-800/50' : 'bg-gray-100/80';
  const bgInput = isDark ? 'bg-gray-900' : 'bg-white';
  //const bgDropdown = isDark ? 'bg-gray-800' : 'bg-white';
  //const bgDropdownItem = isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100';
  //const bgModal = isDark ? 'bg-gray-800' : 'bg-white';
  const bgProgress = isDark ? 'bg-gray-900' : 'bg-gray-200';
  
  const borderColor = isDark ? 'border-blue-800/40' : 'border-gray-200';
  //const borderLight = isDark ? 'border-blue-800/30' : 'border-gray-200';
  const borderInput = isDark ? 'border-gray-700' : 'border-gray-300';
  const borderFocus = isDark ? 'focus:border-blue-500' : 'focus:border-blue-500';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-blue-700';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  //const textLight = isDark ? 'text-gray-400' : 'text-gray-600';
  //const textBlue = isDark ? 'text-blue-100' : 'text-blue-800';
  
  const shadowColor = isDark ? 'shadow-blue-900/20' : 'shadow-blue-200/50';
  const shadowModal = isDark ? 'shadow-2xl' : 'shadow-xl';

  // Parse user if it's a string
  const userData = typeof user === 'string' ? JSON.parse(user) : user;
  console.log("User Details:", userData);
  
  const allusers = typeof users === 'string' ? JSON.parse(users) : users;
  const alldevices = typeof devices === 'string' ? JSON.parse(devices) : devices;

  // Get role-specific display name and email
  const getDisplayName = () => {
    if (userData?.role === 'Manager') {
      return userData?.manager_name || 'N/A';
    } else if (userData?.role === 'Organization') {
      return userData?.org_name || 'N/A';
    }
    return userData?.name || 'N/A';
  };

  const getDisplayEmail = () => {
    if (userData?.role === 'Manager') {
      return userData?.manager_email || 'N/A';
    } else if (userData?.role === 'Organization') {
      return userData?.org_email || 'N/A';
    }
    return userData?.email || 'N/A';
  };

  const getInitials = () => {
    const name = getDisplayName();
    return name.charAt(0).toUpperCase();
  };

  const getLocation = () => {
    if (userData?.role === 'Manager') {
      return userData?.org_id?.location || userData?.location || 'Not specified';
    } else {
      return userData?.location || 'Not specified';
    }
  };

  const getLicenseKey = () => {
    if (userData?.role === 'Manager') {
      return userData?.org_id?.license_key || 'N/A';
    } else {
      return userData?.license_key || 'N/A';
    }
  };

  const getOrganizationName = () => {
    if (userData?.role === 'Manager') {
      return userData?.org_id?.org_name || 'N/A';
    }
    return null;
  };

  const getTotalDevices = () => {
    if (userData?.role === 'Manager') {
      return alldevices.length || 0;
    } else {
      return alldevices.length || 0;
    }
  };

  const getTotalUsers = () => {
    if (userData?.role === 'Manager') {
      return allusers.length || 0;
    } else {
      return allusers.length || 0;
    }
  };

  useEffect(() => {
      if (!socket) return;
  
      socket.on("Notification_Status", (data) => {
        console.log("Notification:",data)
        dispatch(profile(token))
      });
  
      return () => {
        socket.off("Notification_Status");
      };
    }, [socket, dispatch, token]);

  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 800);
  }, []);

  useEffect(() => {
    if (allusers && Array.isArray(allusers)) {
      let activeusers = allusers?.filter((u) => u.status === true || u.status === 'ACTIVE');
      setActiveUser(activeusers?.length || 0);
    }
    
    if (alldevices && Array.isArray(alldevices)) {
      let activedevices = alldevices?.filter((d) => d.last_status === 'ONLINE' || d.last_status === 'HEARTBEAT');
      setActiveDevice(activedevices?.length || 0);
    }
  }, [users, devices, alldevices, allusers]);

  // Get user's current timezone
  useEffect(() => {
    const savedTimeZone = userData?.timeZone;
    if (savedTimeZone && savedTimeZone.timezone) {
      setSelectedTimeZone(savedTimeZone.timezone);
    } else {
      const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const matchedTimeZone = timeZones.find(tz => 
        browserTimeZone.toLowerCase().includes(tz.value.toLowerCase().split(' ')[0].toLowerCase())
      ) || timeZones[12];
      
      if (userData?.role === 'Manager') {
        dispatch(SetTimeZone({timezone: matchedTimeZone.name, value: matchedTimeZone.value}));
      } else {
        dispatch(Org_SetTimeZone({timezone: matchedTimeZone.name, value: matchedTimeZone.value}));
      }
      setSelectedTimeZone(matchedTimeZone.name);
    }
  }, [dispatch, userData?.role, userData?.timeZone]);

  const handleTimeZoneChange = (timeZone) => {
    setSelectedTimeZone(timeZone.name);
    if (userData?.role === 'Manager') {
      dispatch(SetTimeZone({timezone: timeZone.name, value: timeZone.value}));
    } else {
      dispatch(Org_SetTimeZone({timezone: timeZone.name, value: timeZone.value}));
    }
    setIsTimeZoneOpen(false);
    setSearchTerm('');
  };

  const handleChangePassword = async () => {
    if (!passwordForm.currentPassword) {
      toast.error("Please enter current password");
      return;
    }
    if (!passwordForm.newPassword) {
      toast.error("Please enter new password");
      return;
    }
    if (passwordForm.newPassword.length < 6) {
      toast.error("New password must be at least 6 characters long");
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    setPasswordLoading(true);
    
    const payload = {
      oldPassword: passwordForm.currentPassword,
      newPassword: passwordForm.newPassword,
      confirmPassword: passwordForm.newPassword
    };

    try {
      let response;
      if (userData?.role === 'Manager') {
        response = await dispatch(ManagerChangePassword(payload, token));
      } else {
        response = await dispatch(OrgChangePassword(payload, token));
      }
      
      if (response?.data?.success) {
        setIsPasswordModalOpen(false);
        setPasswordForm({
          currentPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        toast.success(response.data.message || "Password changed successfully");
      }
      else {
        toast.error(response.data.message || "Error changing password");
      }
    } catch (error) {
      console.error("Password change error:", error);
    } finally {
      setPasswordLoading(false);
    }
  };

  const handlePasswordInputChange = (e) => {
    setPasswordForm({
      ...passwordForm,
      [e.target.name]: e.target.value
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.menu-container')) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuOpen]);

  const filteredTimeZones = timeZones.filter(tz =>
    tz.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tz.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <StandardSpinner />;
  }

  if (!userData) {
    return (
      <section className={`p-6 border ${shadowColor} ${bgCard} ${borderColor} rounded-2xl transition-colors duration-300`}>
        <div className="py-8 text-center">
          <p className={isDark ? 'text-blue-300' : 'text-gray-600'}>No user data available</p>
        </div>
      </section>
    );
  }

  return (
    <section className={`p-6 border ${shadowColor} ${bgCard} ${borderColor} rounded-2xl transition-colors duration-300`}>
      {/* Header with 3-dot button */}
      <div className="flex items-center justify-between mb-6">
        <h2 className={`flex items-center gap-2 text-xl font-semibold ${isDark ? 'text-blue-100' : 'text-blue-800'}`}>
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
              clipRule="evenodd"
            />
          </svg>
          Profile Overview
        </h2>
        
        {/* 3-Dot Button Menu */}
        <div className="relative menu-container">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`p-2 transition-colors rounded-lg ${isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-100'} focus:outline-none`}
          >
            <svg className={`w-5 h-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </button>
          
          {/* Dropdown Menu */}
          {isMenuOpen && (
            <div className={`absolute right-0 z-50 w-48 mt-2 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-lg shadow-lg transition-colors duration-300`}>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  setIsPasswordModalOpen(true);
                }}
                className={`flex items-center w-full gap-2 px-4 py-2 text-left ${isDark ? 'text-gray-300 hover:bg-gray-700 hover:text-white' : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'} transition-colors rounded-lg`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                Change Password
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* Profile Info */}
        <div className="space-y-4 lg:col-span-2">
          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center w-20 h-20 text-2xl font-bold text-white border-2 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
              {getInitials()}
            </div>

            <div>
              <h3 className={`text-2xl font-bold ${textPrimary}`}>
                {getDisplayName()}
              </h3>
              <p className={isDark ? 'text-blue-300' : 'text-blue-600'}>{userData?.role || "N/A"}</p>
              <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                {getDisplayEmail()}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 pt-4 md:grid-cols-3">
            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Role</p>
              <p className={`text-sm font-medium ${textPrimary}`}>
                {userData?.role || "N/A"}
              </p>
            </div>

            {userData?.role === "Manager" && userData?.department && (
              <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
                <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Department</p>
                <p className={`text-sm font-medium ${textPrimary}`}>
                  {userData?.department}
                </p>
              </div>
            )}

            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Location</p>
              <p className={`text-sm font-medium ${textPrimary}`}>
                {getLocation()}
              </p>
            </div>

            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>License Key</p>
              <p className={`font-mono text-sm font-medium ${textPrimary}`}>
                {getLicenseKey() !== 'N/A' && getLicenseKey() !== 'Secret' 
                  ? `${getLicenseKey().substring(0, 8)}...` 
                  : getLicenseKey()}
              </p>
            </div>

            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Status</p>
              <p className="font-medium">
                <span className={`px-2 py-1 rounded-full text-xs ${
                  userData?.status === true || userData?.status === 'ACTIVE' 
                    ? 'bg-green-500/20 text-green-600' 
                    : 'bg-red-500/20 text-red-400'
                }`}>
                  {userData?.status === true || userData?.status === 'ACTIVE' ? "Active" : "Inactive"}
                </span>
              </p>
            </div>

            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Member since</p>
              <p className={`text-xs font-medium ${textPrimary}`}>
                {userData?.createdAt ? new Date(userData.createdAt).toLocaleDateString() : 'N/A'}
              </p>
            </div>

            <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
              <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Last updated</p>
              <p className={`text-xs font-medium ${textPrimary}`}>
                {userData?.updatedAt ? new Date(userData.updatedAt).toLocaleDateString() : 'N/A'}
              </p>
            </div>

            {userData?.role === "Manager" && getOrganizationName() && (
              <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
                <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Organization</p>
                <p className={`text-sm font-medium ${textPrimary}`}>
                  {getOrganizationName()}
                </p>
              </div>
            )}

            {userData?.role === "Organization" && userData?.wallet && (
              <div className={`p-3 rounded-lg ${bgSection} transition-colors duration-300`}>
                <p className={`mb-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-700'}`}>Wallet Balance</p>
                <p className={`text-sm font-medium ${textPrimary}`}>
                  ₹{userData?.wallet?.balance || 0}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Profile Stats and TimeZone */}
        <div className="space-y-4">
          {/* Quick Stats */}
          <div className={`p-4 border ${bgSection} ${borderColor} rounded-xl transition-colors duration-300`}>
            <h4 className={`mb-4 font-medium ${isDark ? 'text-blue-100' : 'text-blue-800'}`}>Quick Stats</h4>

            <div className="space-y-4">
              <div>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Active Devices</span>
                  <span className={`text-lg font-bold ${textPrimary}`}>
                    {activeDevice || 0} / {getTotalDevices()}
                  </span>
                </div>
                <div className={`w-full h-2 ${bgProgress} rounded-full`}>
                  <div
                    className="h-2 transition-all duration-500 bg-blue-600 rounded-full"
                    style={{
                      width: `${getTotalDevices() > 0 
                        ? (Number(activeDevice || 0) / Number(getTotalDevices())) * 100 
                        : 0}%`
                    }}
                  ></div>
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Active Users</span>
                  <span className={`text-lg font-bold ${textPrimary}`}>
                    {activeUser || 0} / {getTotalUsers()}
                  </span>
                </div>
                <div className={`w-full h-2 ${bgProgress} rounded-full`}>
                  <div
                    className="h-2 transition-all duration-500 bg-blue-600 rounded-full"
                    style={{ 
                      width: `${getTotalUsers() > 0 
                        ? (Number(activeUser || 0) / Number(getTotalUsers())) * 100 
                        : 0}%` 
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          {/* TimeZone Section */}
          <div className={`p-4 border ${bgSection} ${borderColor} rounded-xl transition-colors duration-300`}>
            <div className="flex items-center justify-between mb-4">
              <h4 className={`flex items-center gap-2 font-medium ${isDark ? 'text-blue-100' : 'text-blue-800'}`}>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                Time Zone
              </h4>
            </div>

            {/* Selected TimeZone Display */}
            <div 
              onClick={() => setIsTimeZoneOpen(!isTimeZoneOpen)}
              className={`w-full p-3 transition-colors ${isDark ? 'bg-gray-900 border-blue-800/30 hover:border-blue-600/50' : 'bg-gray-50 border-gray-300 hover:border-blue-400'} border rounded-lg cursor-pointer transition-colors duration-300`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className={`text-sm font-medium ${textPrimary}`}>
                    {selectedTimeZone || 'Select Time Zone'}
                  </p>
                  <p className={`mt-1 text-xs ${isDark ? 'text-blue-200' : 'text-blue-600'}`}>
                    {timeZones.find(tz => tz.name === selectedTimeZone)?.value || ''}
                  </p>
                </div>
                <svg 
                  className={`h-5 w-5 ${isDark ? 'text-gray-400' : 'text-gray-500'} transition-transform ${isTimeZoneOpen ? 'rotate-180' : ''}`} 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>

            {/* TimeZone Dropdown */}
            {isTimeZoneOpen && (
              <div className={`mt-2 overflow-hidden ${isDark ? 'bg-gray-900 border-blue-800/30' : 'bg-white border-gray-300'} border rounded-lg transition-colors duration-300`}>
                {/* Search Input */}
                <div className={`p-2 border-b ${isDark ? 'border-blue-800/30' : 'border-gray-200'}`}>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search timezone..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className={`w-full py-2 pl-8 pr-3 text-sm ${textPrimary} ${isDark ? 'bg-gray-800 border-blue-800/30' : 'bg-gray-50 border-gray-300'} border rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors duration-300`}
                    />
                    <svg 
                      className={`h-4 w-4 ${isDark ? 'text-gray-400' : 'text-gray-500'} absolute left-2.5 top-2.5`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>

                {/* TimeZone List */}
                <div className="overflow-y-auto max-h-48 custom-scrollbar">
                  {filteredTimeZones.map((tz, index) => (
                    <div
                      key={index}
                      onClick={() => handleTimeZoneChange(tz)}
                      className={`px-3 py-2 cursor-pointer transition-colors ${
                        isDark ? 'hover:bg-blue-600/20' : 'hover:bg-blue-50'
                      } ${
                        selectedTimeZone === tz.name ? 'bg-blue-600/30 border-l-2 border-blue-500' : ''
                      }`}
                    >
                      <p className={`text-sm ${textPrimary}`}>{tz.name}</p>
                      <p className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>{tz.value}</p>
                    </div>
                  ))}
                  {filteredTimeZones.length === 0 && (
                    <div className={`px-3 py-4 text-sm text-center ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                      No timezones found
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* TimeZone Info */}
            <div className={`flex items-center gap-1 mt-3 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <span>Your timezone affects how dates and times are displayed</span>
            </div>
          </div>
        </div>
      </div>

      {/* Change Password Modal */}
      {isPasswordModalOpen && (
        <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}>
          <div className={`w-full max-w-md p-6 ${isDark ? 'bg-gray-800 border-blue-700' : 'bg-white border-gray-300'} border ${shadowModal} rounded-xl transition-colors duration-300`}>
            <div className="flex items-center justify-between mb-4">
              <h2 className={`text-2xl font-bold ${textPrimary}`}>Change Password</h2>
              <button
                onClick={() => setIsPasswordModalOpen(false)}
                className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'} transition-colors`}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <form onSubmit={(e) => { e.preventDefault(); handleChangePassword(); }}>
              {/* Current Password */}
              <div className="mb-4">
                <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                  Current Password
                </label>
                <div className="relative">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    name="currentPassword"
                    value={passwordForm.currentPassword}
                    onChange={handlePasswordInputChange}
                    className={`w-full px-4 py-2 pr-10 ${textPrimary} ${bgInput} border ${borderInput} rounded-lg focus:outline-none ${borderFocus} transition-colors duration-300`}
                    placeholder="Enter current password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    className={`absolute right-3 top-2.5 ${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}
                  >
                    {showCurrentPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* New Password */}
              <div className="mb-4">
                <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                  New Password
                </label>
                <div className="relative">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={handlePasswordInputChange}
                    className={`w-full px-4 py-2 pr-10 ${textPrimary} ${bgInput} border ${borderInput} rounded-lg focus:outline-none ${borderFocus} transition-colors duration-300`}
                    placeholder="Enter new password (min 6 characters)"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    className={`absolute right-3 top-2.5 ${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}
                  >
                    {showNewPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Confirm Password */}
              <div className="mb-6">
                <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                  Confirm New Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={passwordForm.confirmPassword}
                    onChange={handlePasswordInputChange}
                    className={`w-full px-4 py-2 pr-10 ${textPrimary} ${bgInput} border ${borderInput} rounded-lg focus:outline-none ${borderFocus} transition-colors duration-300`}
                    placeholder="Confirm new password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className={`absolute right-3 top-2.5 ${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}
                  >
                    {showConfirmPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Password Strength Indicator */}
              {passwordForm.newPassword && (
                <div className="mb-4">
                  <div className={`flex justify-between mb-1 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    <span>Password strength:</span>
                    <span>
                      {passwordForm.newPassword.length < 6 ? "Too short" :
                       passwordForm.newPassword.length < 8 ? "Weak" :
                       passwordForm.newPassword.match(/[!@#$%^&*(),.?":{}|<>]/) ? "Strong" : "Medium"}
                    </span>
                  </div>
                  <div className={`w-full ${isDark ? 'bg-gray-700' : 'bg-gray-200'} rounded-full h-1.5`}>
                    <div 
                      className={`h-1.5 rounded-full transition-all ${
                        passwordForm.newPassword.length < 6 ? "bg-red-500 w-1/4" :
                        passwordForm.newPassword.length < 8 ? "bg-yellow-500 w-2/4" :
                        passwordForm.newPassword.match(/[!@#$%^&*(),.?":{}|<>]/) ? "bg-green-500 w-full" : "bg-blue-500 w-3/4"
                      }`}
                    ></div>
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setIsPasswordModalOpen(false)}
                  className={`flex-1 px-4 py-2 text-white transition-colors ${isDark ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-500 hover:bg-gray-600'} rounded-lg`}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={passwordLoading}
                  className="flex items-center justify-center flex-1 gap-2 px-4 py-2 text-white transition-colors bg-blue-700 rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {passwordLoading ? (
                    <>
                      <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Changing...
                    </>
                  ) : (
                    "Change Password"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add custom scrollbar styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: ${isDark ? '#1f2937' : '#f3f4f6'};
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #3b82f6;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #2563eb;
        }
      `}</style>
    </section>
  );
};

export default ProfileOverview;
